<div class="truncate leading-5 text-subtitle flex gap-2 items-center">
  @for (label of data; track $index) {
    {{ label }}
    @if (!$last) {
      <svg-icon class="flex h-1 w-1 text-subtitle" src="assets/icons/icon-ellipse.svg"></svg-icon>
    }
  }
</div>
